export type Error = {
  field: string;
  message: string;
};

export type FastApiError = {
  detail: {
    loc: string[];
    msg: string;
    type: string;
  }[];
};

export type CustomError = {
  detail: string;
};

function isError(error: Error | FastApiError | CustomError): error is Error {
  return (error as Error).field !== undefined;
}

function isCustomError(
  error: Error | FastApiError | CustomError,
): error is CustomError {
  return typeof (error as CustomError).detail === 'string';
}

export class CDError extends Error {
  fields?: Record<string, string>;

  constructor(
    message = 'Something went wrong!',
    error?: Error | FastApiError | CustomError,
  ) {
    if (error == null) {
      super(message);
      return;
    }

    if (isCustomError(error)) {
      super(error.detail);
      return;
    }

    if (isError(error)) {
      super(message);
      this.fields = {
        [error.field]: error.message,
      };
      return;
    }

    if (error.detail.length === 1) {
      const entry = error.detail[0];
      if (entry.type === 'value_error') {
        super(entry.msg.slice(12));
        return;
      }
    }

    super(message);
    this.fields = error.detail.reduce<Record<string, string>>(
      (acc, { type, msg }) => {
        if (type.startsWith('value_error.')) {
          acc[type.slice(12)] = msg;
        }
        return acc;
      },
      {},
    );
  }
}
